import React from "react";
import { useNavigate } from "react-router-dom";
import "./WhyEmerald.css";

/**
 * Props:
 * - imageSrc: right-side image path (default: /why-emerald.jpg in /public)
 * - onCta: optional click handler for CTA (falls back to navigate to /about)
 */
export default function WhyEmerald({
  imageSrc = `${process.env.PUBLIC_URL}/why-emerald.jpg`,
  onCta,
}) {
  const navigate = useNavigate();

  const handleCta = () => {
    if (typeof onCta === "function") {
      return onCta();
    }
    // Default: go to About page using React Router
    navigate("/about");
  };

  return (
    <section className="WhyEmerald" aria-labelledby="we-title">
      <div className="WhyEmerald__container">
        {/* Left: Text */}
        <div className="WhyEmerald__content">
          <p className="WhyEmerald__eyebrow">Why Emerald Appraisal Services</p>

          <h2 id="we-title" className="WhyEmerald__title">
            Accuracy, integrity, and local expertise you can count on
          </h2>

          <p className="WhyEmerald__lead">
            We deliver clear, well-supported residential valuations across the
            Greater Puget Sound—Pierce, King, Thurston, Kitsap, Lewis, Mason, Grays Harbor
            and Snohomish counties. Reports are timely, lender-ready, and
            easy to understand.
          </p>

          <ul className="WhyEmerald__list">
            <li className="WhyEmerald__item">
              <span className="WhyEmerald__icon" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none">
                  <path
                    d="M7.5 10.8l-2-2L4 10.3l3.5 3.5L16 5.3l-1.6-1.6-6.9 7.1z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <div>
                <h3 className="WhyEmerald__point">Certified &amp; FHA-Approved</h3>
                <p className="WhyEmerald__desc">
                  USPAP-compliant reports completed by a Certified Residential
                  Appraiser.
                </p>
              </div>
            </li>

            <li className="WhyEmerald__item">
              <span className="WhyEmerald__icon" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none">
                  <path
                    d="M7.5 10.8l-2-2L4 10.3l3.5 3.5L16 5.3l-1.6-1.6-6.9 7.1z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <div>
                <h3 className="WhyEmerald__point">Local Market Insight</h3>
                <p className="WhyEmerald__desc">
                  Deep knowledge of neighborhood trends, comparables, and county
                  nuances.
                </p>
              </div>
            </li>
          </ul>

          <div className="WhyEmerald__badges" aria-label="Trust badges">
            <span className="WhyEmerald__badge">
              Trusted by lenders &amp; attorneys
            </span>
            <span className="WhyEmerald__badge">
              Serving Pierce, King &amp; beyond
            </span>
          </div>

          <button
            className="WhyEmerald__cta"
            onClick={handleCta}
            type="button"
            aria-label="Learn more"
          >
            Learn more
            <svg
              className="WhyEmerald__cta-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        {/* Right: Image */}
        <div className="WhyEmerald__media" aria-hidden="true">
          <div className="WhyEmerald__frame">
            <img
              className="WhyEmerald__img"
              src={imageSrc}
              alt=""
              width={1120}
              height={800}
              loading="lazy"
              decoding="async"
            />
            <div className="WhyEmerald__image-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
